/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a YouTube link above to see every thumbnail size.`)
};

const es_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un enlace de YouTube arriba para ver todos los tamaños de miniatura.`)
};

const de_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge oben einen YouTube-Link ein, um alle Thumbnail-Größen zu sehen.`)
};

const nl_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een YouTube-link om elk thumbnailformaat te bekijken.`)
};

const fr_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un lien YouTube ci-dessus pour voir toutes les tailles de miniature.`)
};

const it_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un link YouTube qui sopra per vedere tutte le dimensioni della miniatura.`)
};

const pt_br2_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um link do YouTube acima para ver todos os tamanhos de thumbnail.`)
};

const pt_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um link do YouTube acima para ver todos os tamanhos de miniatura.`)
};

const ja_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にYouTubeのリンクを貼り付けると、すべてのサムネイルサイズを確認できます。`)
};

const zh_yt_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴 YouTube 链接，即可查看所有缩略图尺寸。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hint", locale)
	if (locale === "en") return en_yt_hint(inputs)
	if (locale === "es") return es_yt_hint(inputs)
	if (locale === "de") return de_yt_hint(inputs)
	if (locale === "nl") return nl_yt_hint(inputs)
	if (locale === "fr") return fr_yt_hint(inputs)
	if (locale === "it") return it_yt_hint(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hint(inputs)
	if (locale === "pt") return pt_yt_hint(inputs)
	if (locale === "ja") return ja_yt_hint(inputs)
	return zh_yt_hint(inputs)
};